module.exports = __webpack_public_path__ + "assets/media/purple-arrow.766655ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookWebinarStep/purple-arrow.svg
// module id = 3182
// module chunks = 0